// extracted by mini-css-extract-plugin
module.exports = {"container":"rootResponse__container___2aflL"};